// Extrae [lat, lng] del campo `maps` de una propiedad.
// El campo guarda un embed de Google Maps en dos formatos posibles:
//   - iframe con "...!2d<lng>!3d<lat>..."  (mapa con pin)
//   - URL corta "...q=<lat>,<lng>&output=embed"
// Devuelve null si no encuentra coordenadas.
export const parseCoords = (maps) => {
  if (!maps || typeof maps !== "string") return null;

  // Formato iframe: !2d = longitud, !3d = latitud
  let m = maps.match(/!2d(-?\d+(?:\.\d+)?)!3d(-?\d+(?:\.\d+)?)/);
  if (m) return [parseFloat(m[2]), parseFloat(m[1])];

  // Formato q=lat,lng
  m = maps.match(/q=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
  if (m) return [parseFloat(m[1]), parseFloat(m[2])];

  return null;
};
